import { createStore } from 'vuex'
import snackBarModule from "@/store/snackbar";

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    snackBarModule,
  }
})
